<template>
  <div class="flex-col page">
    <div class="flex-row justify-between group">
      <div class="flex-row self-start group_2">
        <span class="font text">视频</span>
        <span class="ml-68 font text_2" @click="$router.push('/zhuanti')">专题</span>
      </div>
      <img
        class="image"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=7f83a0edaf88e69e747431d44a163903.png"
      />
    </div>
    <div class="mt-24 flex-col group_3 view">
      <div class="flex-row self-stretch group_3" style="overflow-x: scroll">
        <span class="shrink-0 font_2 text_3" @click="tag=0" :class="{'activate': tag===0}">所有</span>
        <span class="shrink-0 font_2 text_4 ml-11" @click="tag=1" :class="{'activate': tag===1}">行业资讯</span>
        <span class="shrink-0 font_2 ml-11" @click="tag=2" :class="{'activate': tag===2}">案例分享</span>
        <span class="shrink-0 font_2 text_5 ml-11" @click="tag=3" :class="{'activate': tag===3}">保险科普</span>
        <span class="shrink-0 font_2 text_6 ml-11" @click="tag=4" :class="{'activate': tag===4}">产品测评</span>
        <span class="shrink-0 font_2 text_7 ml-11" @click="tag=5" :class="{'activate': tag===5}" style="margin-right: 20px">销售话术</span>
      </div>
<!--      <div class="self-start section"></div>-->
      <div class="grid">
        <div class="flex-col grid-item" @click="$router.push('/xiangqingye')"  v-if="[0,1].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_2">
            <div class="shrink-0 section_3"></div>
            <div class="flex-col justify-start items-center text-wrapper pos">
              <span class="font_3 text_8">行业资讯</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_9">重磅！2024年保险新规要来了，这些变化</span>
        </div>
        <div class="flex-col grid-item" @click="$router.push('/xiangqingye')"  v-if="[0,1].includes(tag)">
        <div class="flex-col justify-start self-stretch relative section_4">
            <div class="shrink-0 section_5"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_2">
              <span class="font_3">保险科普</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_10">最新：2024年学平险保障范围全面扩大</span>
        </div>
        <div class="flex-col grid-item" v-if="[0,3].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_6">
            <div class="shrink-0 section_7"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_3">
              <span class="font_3">保险科普</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_10">某某保险新品深度解析，亮点在这里</span>
        </div>
        <div class="flex-col grid-item" v-if="[0,5].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_8">
            <div class="shrink-0 section_9"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_4">
              <span class="font_3 text_11">销售话术</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_12">销售冠军独家分享：如何提升成单率</span>
        </div>
        <div class="flex-col grid-item" v-if="[0,4].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_2">
            <div class="shrink-0 section_3"></div>
            <div class="flex-col justify-start items-center text-wrapper pos">
              <span class="font_3 text_8">产品测评</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_9">重疾险vs防癌险，如何选择更划算？</span>
        </div>
        <div class="flex-col grid-item" v-if="[0,3].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_4">
            <div class="shrink-0 section_5"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_2">
              <span class="font_3">保险科普</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_10">核保医生告诉你：健康告知怎么填最容易</span>
        </div>
        <div class="flex-col grid-item"  v-if="[0,1].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_6">
            <div class="shrink-0 section_7"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_3">
              <span class="font_3">行业资讯</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_10">重疾险定义修订，这些病种被调整</span>
        </div>
        <div class="flex-col grid-item"  v-if="[0,1].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_8">
            <div class="shrink-0 section_9"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_4">
              <span class="font_3 text_11">行业资讯</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_12">互联网保险大变革，线上投保有了新</span>
        </div>
        <div class="flex-col grid-item" v-if="[0,4].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_2">
            <div class="shrink-0 section_3"></div>
            <div class="flex-col justify-start items-center text-wrapper pos">
              <span class="font_3 text_8">产品测评</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_9">横评2024年主流重疾险，优劣完整对比</span>
        </div>
        <div class="flex-col grid-item" v-if="[0,5].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_4">
            <div class="shrink-0 section_5"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_2">
              <span class="font_3">销售话术</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_10">这样讲解保险，客户秒懂还说好</span>
        </div>
        <div class="flex-col grid-item" v-if="[0,3].includes(tag)">
          <div class="flex-col justify-start self-stretch relative section_6">
            <div class="shrink-0 section_7"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_3">
              <span class="font_3">保险科普</span>
            </div>
          </div>
          <span class="mt-6 self-center font_4 text_10">一个保险条款的前世今生，看完秒懂</span>
        </div>
      </div>
      <div class="flex-row self-stretch relative bottom">
        <div class="section_10"></div>
        <div class="flex-col shrink-0 section_12 pos_6">
          <div class="flex-row justify-between">
            <img
              class="image_4"
              src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=9f5112687f44aaca4f0ffc0181e0d62d.png"
            />
            <img
              @click="$router.push('/xiangce')"
              class="image_4"
              src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=583c5fb06c92fb3306dfd6d4a531c8b8.png"
            />
            <img
              @click="$router.push('/wode')"
              class="image_4"
              src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=0a46c269bca69f2c4e3e6be4818af774.png"
            />
          </div>
          <div class="mt-4 flex-row justify-between">
            <span class="font_5 text_13">主页</span>
            <span class="font_5">相册</span>
            <span class="font_5">我的</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {
        tag: 0
      };
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .ml-11 {
    margin-left: 11px;
  }
  .page {
    padding-left: 24px;
    padding-top: 37px;
    background-color: rgb(17, 17, 17);
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    .group {
      padding: 0 11px;
      .group_2 {
        margin-left: 82px;
        .font {
          font-size: 18px;
          font-family: Barlow;
          line-height: 17px;
        }
        .text {
          color: rgb(85, 239, 227);
          font-weight: 700;
        }
        .text_2 {
          color: rgba(255, 255, 255, 0.5);
          line-height: 16.5px;
        }
      }
      .image {
        width: 26px;
        height: 26px;
      }
    }
    .group_3 {
      overflow-x: hidden;
      .font_2 {
        font-size: 16px;
        font-family: Barlow;
        line-height: 15px;
        color: rgb(164 168 171);
        &.activate {
          color: rgb(85, 239, 227);
        }
      }
      .text_3 {
        font-weight: 600;
        line-height: 15px;
      }
      .text_4 {
        line-height: 14.5px;
      }
      .text_5 {
        line-height: 14.5px;
      }
      .text_6 {
        line-height: 15px;
      }
      .text_7 {
        line-height: 14.5px;
      }
      .section {
        margin-left: 7px;
        margin-top: 8px;
        background-color: rgb(85, 239, 227);
        border-radius: 50%;
        width: 4px;
        height: 4px;
      }
      .grid {
        margin-right: 24px;
        margin-top: 16px;
        height: 568px;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        row-gap: 17px;
        column-gap: 17px;
        .grid-item {
          padding-bottom: 18px;
          background-color: rgba(255, 255, 255, 0.05);
          border-radius: 16px;
          overflow: hidden;
          height: 276px;
          .section_2 {
            border-radius: 16px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=e1f7185f55a83b30569776d25dbafc57.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_3 {
              border-radius: 16px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=e1f7185f55a83b30569776d25dbafc57.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 204px;
            }
            .pos {
              position: absolute;
              left: 12px;
              top: 168px;
            }
          }
          .font_4 {
            font-size: 16px;
            font-family: Barlow;
            line-height: 24px;
            color: rgb(255, 255, 255);
          }
          .text_9 {
            width: 150px;
          }
          .section_4 {
            border-radius: 16px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=0e5b1ffe1601defadc7685dd03ac0b28.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_5 {
              border-radius: 16px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=0e5b1ffe1601defadc7685dd03ac0b28.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 204px;
            }
            .pos_2 {
              position: absolute;
              left: 12px;
              top: 168px;
            }
          }
          .text-wrapper {
            padding: 4px 0 8px;
            background-color: rgb(85, 239, 227);
            border-radius: 8px;
            width: 64px;
            .font_3 {
              font-size: 12px;
              font-family: Barlow;
              line-height: 11px;
              color: rgb(17, 17, 17);
              margin-top: 2px;
            }
            .text_8 {
              line-height: 11px;
            }
            .text_11 {
              line-height: 11px;
            }
          }
          .text_10 {
            width: 150px;
          }
          .section_6 {
            border-radius: 16px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=95d4abdcb8b1a00e62a9173603d5604b.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_7 {
              border-radius: 16px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=95d4abdcb8b1a00e62a9173603d5604b.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 204px;
            }
            .pos_3 {
              position: absolute;
              left: 12px;
              top: 168px;
            }
          }
          .section_8 {
            border-radius: 16px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=7a30da58974db287d9690644551fd280.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_9 {
              border-radius: 16px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=7a30da58974db287d9690644551fd280.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 204px;
            }
            .pos_4 {
              position: absolute;
              left: 12px;
              top: 168px;
            }
          }
          .text_12 {
            margin-top: 5px;
            width: 150px;
          }
        }
      }
      .bottom {
        position: fixed;
        bottom: -76px;
        .section_10 {
          flex: 1 1 163px;
          border-radius: 16px;
          overflow: hidden;
          height: 204px;
        }
        .section_11 {
          margin-left: 16px;
          margin-right: 20px;
          flex: 1 1 163px;
          background-color: rgba(255, 255, 255, 0.05);
          border-radius: 16px 16px 0 0;
          overflow: hidden;
          height: 204px;
          .image-wrapper {
            border-radius: 16px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=8d77d3e05f086dca95b84a4b56e9e0de.png');
            background-position: 0% 0%;
            background-size: 100%, 100%;
            background-repeat: no-repeat;
            .image_3 {
              width: 162px;
              height: 204px;
            }
          }
        }
        .image_2 {
          border-radius: 16px;
          overflow: hidden;
          background-color: rgba(255, 255, 255, 0.05);
          width: 163px;
          height: 204px;
        }
        .pos_5 {
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .section_12 {
          padding: 8px 40px 12px;
          background-color: rgb(255, 255, 255);
          border-radius: 32px;
          filter: drop-shadow(-2px 4px 2px #8c8c8c26);
          width: 289px;
          .image_4 {
            width: 24px;
            height: 24px;
          }
          .font_5 {
            font-size: 10px;
            font-family: Nunito;
            line-height: 9px;
            color: rgb(166, 166, 166);
          }
          .text_13 {
            color: rgb(46, 5, 5);
            line-height: 9px;
          }
        }
        .pos_6 {
          position: absolute;
          left: 26.5px;
          top: 41px;
        }
      }
    }
    .view {
      margin-bottom: -75px;
    }
  }
</style>
